
import React, { useState } from 'react';
import { Container, Navbar, Nav, Button, Offcanvas } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { 
  Building, Users, GitBranch, Menu, X, 
  Home, Settings, LogOut 
} from 'lucide-react';

const DashboardComponent = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const location = useLocation();

  const menuItems = [
    { path: '/SoftworksStore', icon: <Home size={20} />, title: 'Softworks Store' },
    { path: '/SoftworksAdminAccountQoutation', icon: <Building size={20} />, title: 'Quatation' },
    { path: '/Invoice', icon: <GitBranch size={20} />, title: 'Invoice' },
    { path: '/Proforma', icon: <Users size={20} />, title: 'Proforma' },
    { path: '/SoftworksAdminAccountPayments', icon: <Settings size={20} />, title: 'Account Payments' },
    { path: '/SoftworksAdminAccountInvoice', icon: <Settings size={20} />, title: 'Account Invoice' },
    { path: '/CustomerSelection', icon: <Settings size={20} />, title: 'Account Statement' },
    { path: '/ShiftClosingReport', icon: <Settings size={20} />, title: 'Close Shift' },
    { path: '/SoftworksAdminReports', icon: <Settings size={20} />, title: 'Reports' },
  ];

  return (
    <div className="d-flex">
      {/* TopBar */}
      <Navbar 
        fixed="top" 
        className="w-100" 
        style={{ backgroundColor: '#B03F82', zIndex: 1030 }}
      >
        <Container fluid>
          <Button
            variant="link"
            className="text-white d-md-none"
            onClick={() => setShowSidebar(true)}
          >
            <Menu size={24} />
          </Button>
          
          <Navbar.Brand className="text-white">
            SOFTWORKS ADMINISTRATION
          </Navbar.Brand>
          
          <Nav className="ms-auto">
            <Button 
              variant="outline-light" 
              size="sm" 
              className="d-flex align-items-center gap-2"
              style={{marginRight: 30}}
            >
              <LogOut size={18} />
              <span className="d-none d-sm-inline">Logout</span>
            </Button>
          </Nav>
        </Container>
      </Navbar>

      {/* Sidebar - Desktop */}
      <div 
        className="d-none d-md-flex flex-column flex-shrink-0 p-3 text-white"
        style={{ 
          width: '280px', 
          backgroundColor: '#B03F82',
          height: '100vh',
          position: 'fixed',
          top: 0,
          paddingTop: '56px',
          marginTop: 40
        }}
      >
        <Nav className="flex-column mb-auto w-100 pt-3">
          {menuItems.map((item) => (
            <Nav.Link
              key={item.path}
              as={Link}
              to={item.path}
              className={`
                mb-2 px-3 py-2 rounded-3 d-flex align-items-center gap-3
                ${location.pathname === item.path ? 'bg-white text-purple' : 'text-white'}
              `}
              style={{ 
                transition: 'all 0.3s',
                ':hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
              }}
            >
              {item.icon}
              {item.title}
            </Nav.Link>
          ))}
        </Nav>
      </div>

      {/* Sidebar - Mobile */}
      <Offcanvas 
        show={showSidebar} 
        onHide={() => setShowSidebar(false)}
        className="d-md-none"
        style={{ backgroundColor: '#B03F82' }}
      >
        <Offcanvas.Header className="border-bottom border-light">
          <Offcanvas.Title className="text-white">Menu</Offcanvas.Title>
          <Button 
            variant="link" 
            className="text-white" 
            onClick={() => setShowSidebar(false)}
          >
            <X size={24} />
          </Button>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            {menuItems.map((item) => (
              <Nav.Link
                key={item.path}
                as={Link}
                to={item.path}
                className={`
                  mb-2 px-3 py-2 rounded-3 d-flex align-items-center gap-3
                  ${location.pathname === item.path ? 'bg-white text-purple' : 'text-white'}
                `}
                onClick={() => setShowSidebar(false)}
              >
                {item.icon}
                {item.title}
              </Nav.Link>
            ))}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Main Content */}
      <div 
        className="flex-grow-1 p-3"
        style={{ 
          marginLeft: '280px',
          marginTop: '56px',
          '@media (max-width: 768px)': {
            marginLeft: 0
          }
        }}
      >
        <Container fluid className="py-3">
          {children}
        </Container>
      </div>
    </div>
  );
};

export default DashboardComponent;

